<template>
  <div
    :class="src.length === 0 ? 'no-image' : ''"
    class="thumbnail__wrapper"
    :style="`${loading ? `height: ${size.h}px; width: ${size.w}px` : ''}`"
  >
    <!--
      We are using native lazy loading.
      This s the best way because we are also using srcset to manage
      retina images. AKA 2x and 3x images.
      @see https://css-tricks.com/the-complete-guide-to-lazy-loading-images/
    -->
    <img
      v-srcset
      class="thumbnail--image"
      :class="customClass"
      :src="thumb(src)"
      :style="{background: loading ? '#eee' : ''}"
      alt
      loading="lazy"
      :height="size.h"
      :width="size.w"
      @click="$emit('click')"
      @load="loading = false"
      @error="error = true"
    >
  </div>
</template>
<script>
export default {
  name: 'BaseThumbnail',
  props: {
    src: {
      type: String,
      default: '',
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    smaller: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    cover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sizes: {
        xsmall: { w: 50, h: 60 },
        smaller: { w: 65, h: 65 },
        small: { w: 80, h: 80 },
        medium: { w: 120, h: 120 },
        large: { w: 188, h: 188 },
      },
      loading: true,
      error: false,
    };
  },
  computed: {

    size() {
      /*
         Return object holding two properties 'w' & 'h' representing
         the width/height to force html-scaling of thumbnails into.
       */
      const DEFAULT_SIZE = this.sizes.medium;
      return this.large ? this.sizes.large
        : this.medium ? this.sizes.medium
          : this.small ? this.sizes.small
            : this.smaller ? this.sizes.smaller
              : this.xsmall ? this.sizes.xsmall
                : DEFAULT_SIZE;
    },
    customClass() {
      return [
        this.hasClickListener ? 'base-thumbnail--clickable' : '',
        this.cover ? 'cover' : '',
      ];
    },
    hasClickListener() {
      return this.$listeners.click || this.$listeners['!click'];
    },
  },
  watch: {
    src: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length) {
          this.error = false;
          this.loading = true;
        }
      },
    },
  },
  methods: {
    thumb(url) {
      if (this.error) {
        return '/img/blank-product.png';
      }
      if (this.isBase64(url)) {
        return url;
      }
      // Shouldn't happen. But if it does, return white transparent pixel.
      // Note that this loads the image and triggers @load
      // eslint-disable-next-line
      if (url.length === 0) return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC';

      // if url is empty, next line would fail.
      const urlObj = new URL(url);
      urlObj.searchParams.set('w', this.size.w);
      urlObj.searchParams.set('h', this.size.h);
      urlObj.searchParams.set('fit', 'fill');
      urlObj.searchParams.set('fill', 'solid');
      // urlObj.searchParams.set('bg', 'ff0');
      return (
        urlObj.href
      );
    },
    isBase64(url) {
      return url.startsWith('data:');
    },
  },
};
</script>
<style lang="scss" scoped>
.base-thumbnail {
  &--clickable {
    cursor: pointer;
  }
}
.cover {
  object-fit: cover;
}
.no-image {
  img {
    opacity: 0;
  }
}

.thumbnail--image{
  background: transparent;
  transition: background 0.2s ease;
}

.thumbnail {
  &__wrapper {
    position: relative;
  }

  &--skeleton {
    position: absolute;
  }
}
</style>
